<style>
  .linc-minimum-order-input {
    width: 10vh;
  }
  .linc-text {
    margin-top: 1vh;
  }
</style>

<template>

  <div class="form-group">
      <div class="form-group--three-columns">
        <ul>
          <li v-for="(item, index) in minimumOrderCoinRollsSettings">
            <div class="form-row">
            <h4>{{ item.bank }}</h4>
            <p class="linc-text">{{ $t('management.unit.softwaresettings.minimumOrderPanel.min') }}</p>
            <el-input class="linc-minimum-order-input"
                  v-model="minimumOrderCoinRollsSettings[index].minimumOrderCoinRoll"
                  type="number"
                  min="1"
                  max="200"
                  @change="updateSettings()"
                  :disabled="!overridden || readOnly"
            ></el-input>
            <p class="linc-text">{{ $t('management.unit.softwaresettings.minimumOrderPanel.max') }}</p>
            <el-input class="linc-minimum-order-input"
                  v-model="minimumOrderCoinRollsSettings[index].maximumOrderCoinRoll"
                  type="number"
                  min="1"
                  max="200"
                  @change="updateSettings()"
                  :disabled="!overridden || readOnly"
            ></el-input>
            </div>
          </li>
        </ul>
      </div>
  </div>

</template>

<script>

  export default {
    name: 'DqMinimumordercoinrollspanel',
    replace: true,
    props: {
      label: '',
      overridden: false,
      minimumOrderCoinRollsSettings: [],
      readOnly: false
    },
    data: function () {
      return {
        minimumOrderCoinRollsSettingsNew: [...this.minimumOrderCoinRollsSettings]
      }
    },
    mounted () {
      this.updateSettings()
    },
    watch: {
      minimumOrderCoinRollsSettings: function () {
        this.updateSettings()
      }
    },
    methods: {
      updateSettings () {
        this.minimumOrderCoinRollsSettingsNew = [...this.minimumOrderCoinRollsSettings]
        this.$store.commit('overrideMinimumOrderCoinRollsSettings/setOverrideMinimumOrderCoinRollsSettings', { minimumOrderCoinRollsSettings: this.minimumOrderCoinRollsSettingsNew })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// minimumordercoinrollspanel.vue?66a43a98